import { Input } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { Col, FormLabel, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import SignatureComponent from "./SignatureComponent";

const Declaration = ({
  errors,
  declarationFormData,
  setDeclarationFormData,
  loading,
  signature,
  setSignature,
}) => {
  const { singleCandidate } = useSelector((state) => state.candidates);
  const handleChange = (name, value) => {
    setDeclarationFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    setDeclarationFormData((prev) => ({
      ...prev,
      itl_declarationname: singleCandidate.lastname || "",
      itl_declarationdate: dayjs().format("YYYY-MM-DD"),
    }));
  }, []);

  return (
    <div>
      <h5 className="mb-3 text-center">Declaration</h5>
      <div style={{ textAlign: "justify" }}>
        <p className="mb-0">
          I,{" "}
          <span className="fw-semibold">
            {declarationFormData.itl_declarationname}
          </span>
          {/* <div className="d-inline-flex flex-column">
            <Input
              placeholder=""
              className={`declaration-input px-2 pb-0 ${
                errors.itl_declarationname ? "error" : ""
              }`}
              onChange={(e) =>
                handleChange("itl_declarationname", e.target.value)
              }
              value={declarationFormData.itl_declarationname}
              disabled={loading}
            />{" "}
            <div className="input-error">{errors.itl_declarationname}</div>{" "}
          </div> */}
          , do hereby solemnly declare and certify that the information given in
          this bio-data form is true to the best of my knowledge and belief. In
          case any information is found to be incorrect at any time, my services
          shall be liable to be terminated from the company without any
          compensation and notice.
        </p>
        <p className="mb-0">
          I am not suffering from any disease which may render me unfit for the
          post applied for or affect my efficiency of work
        </p>
        <p className="mb-0">I have not been convicted by any court of law.</p>
        <p className="mb-0">
          In case of selection and subsequent joining, I further undertake to
          abide by the rules and services regulations of the company as in force
          from time to time.
        </p>
      </div>

      <Row className="mt-5 mb-4">
        <Col xs={12} md={6} className="mb-4">
          <Row>
            <Col xs={2} md={2} className="d-flex align-items-end">
              <div className="fw-semibold text-nowrap">Date :</div>
            </Col>
            <Col xs={10}>
              <div className="d-flex flex-column position-relative">
                <Input
                  // type="date"
                  placeholder=""
                  className={`declaration-input ps-0 pb-0 w-100 ${
                    errors.itl_declarationdate ? "error" : ""
                  }`}
                  // onChange={(e) =>
                  //   handleChange("itl_declarationdate", e.target.value)
                  // }
                  value={
                    declarationFormData.itl_declarationdate
                      ? declarationFormData.itl_declarationdate.slice(0, 10)
                      : ""
                  }
                  disabled={loading}
                />
                <div
                  className="input-error position-absolute"
                  style={{ bottom: "-17px" }}
                >
                  {errors.itl_declarationdate}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={6} className="mb-4">
          <Row>
            <Col xs={2} md={2} className="d-flex align-items-end">
              <div className="fw-semibold text-nowrap">Name :</div>
            </Col>
            <Col xs={10}>
              <div className="d-flex flex-column position-relative">
                <Input
                  placeholder="Name"
                  className={`declaration-input ps-0 pb-0 w-100 ${
                    errors.itl_declarationname ? "error" : ""
                  }`}
                  // onChange={(e) =>
                  //   handleChange("itl_declarationname", e.target.value)
                  // }
                  value={declarationFormData.itl_declarationname}
                  disabled={loading}
                />
                <div
                  className="input-error position-absolute"
                  style={{ bottom: "-17px" }}
                >
                  {errors.itl_declarationname}
                </div>
              </div>
            </Col>
          </Row>
        </Col>

        <Col xs={12} md={6} className="mb-4">
          <Row>
            <Col xs={2} md={2} className="d-flex align-items-end">
              <div className="fw-semibold text-nowrap">Place :</div>
            </Col>
            <Col xs={10}>
              <div className="d-flex flex-column position-relative">
                <Input
                  placeholder="Place"
                  className={`declaration-input ps-0 pb-0 w-100 ${
                    errors.itl_declarationplace ? "error" : ""
                  }`}
                  onChange={(e) =>
                    handleChange("itl_declarationplace", e.target.value)
                  }
                  value={declarationFormData.itl_declarationplace}
                  disabled={loading}
                />
                <div
                  className="input-error position-absolute"
                  style={{ bottom: "-17px" }}
                >
                  {errors.itl_declarationplace}
                </div>
              </div>
            </Col>
          </Row>
        </Col>

        <Col xs={12} md={6} className="mb-4">
          <Row>
            {/* <Col xs={3} md={2} className="d-flex align-items-end">
              <div className="fw-semibold text-nowrap">Signature :</div>
            </Col> */}
            <Col xs={12}>
              <div className="d-flex flex-column position-relative">
                {/* <Input
                  placeholder=""
                  className={`declaration-input ps-0 pb-0 w-100 ${
                    errors.itl_declarationsignature ? "error" : ""
                  }`}
                  onChange={(e) =>
                    handleChange("itl_declarationsignature", e.target.value)
                  }
                  value={declarationFormData.itl_declarationsignature}
                  disabled={loading}
                /> */}
                <FormLabel className="mt-3 fw-semibold text-nowrap">
                  Signature:
                </FormLabel>
                <SignatureComponent
                  value={declarationFormData.itl_candidatesignature}
                  onChange={(value) => {
                    setSignature(value);
                  }}
                  errors={errors}
                  sign={signature}
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <p>
        <span className="fw-semibold">ELECTRONIC SIGNATURE: </span>
        You consent and agree that your use of a keypad, mouse or other device
        to complete the signature section of this declaration agreement
        constitutes your signature, acceptance and agreement as if actually
        signed by you in writing. Further, you agree that no certification
        authority or other third-party verification is necessary to the validity
        of your electronic signature; and that the lack of such certification or
        third-party verification will not in any way affect the enforceability
        of your signature or resulting contract. 
      </p>
    </div>
  );
};

export default Declaration;
